import React from "react";
import { Typography } from "@mui/material";
import Grid from '@mui/material/Grid2';
import PipelineTable from "./PipelineTable";

function PipelineList() {
  return (
    <Grid container spacing={3} sx={{ padding: "20px" }}>
      <Grid item xs={12}>
        <Typography variant="h5" sx={{ color: "#00f5d4", marginBottom: "10px" }}>
           Pipelines
        </Typography>
        <PipelineTable />
      </Grid>
    </Grid>
  );
}

export default PipelineList;
